import * as React from 'react';
import ReactDOM from 'react-dom';
import { App } from './src/ui';

if (
  window?.location?.protocol !== 'https:' &&
  typeof(process) !== 'undefined' &&
  process?.env?.NODE_ENV !== 'development'
) {
  const secureUrl = window.location.href.replace('http:', 'https:');
  window.location.href = secureUrl;
}

ReactDOM.render(<App />, document.getElementById('app'));
